import React, { useEffect, useState } from 'react';
import AuthLayout from '../../layout/authLayout';
import { Typography, Grid, Button, Stack } from '@mui/material';
import InputBox from '../../components/inputBox';
import ApiClient from '../../config/api';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { setPhoneNumber } from '../../store/auth';
import { convertPersianToEnglish } from '../../components/converter';
import checkPwaIos from '../../components/checkPwa';
import CircularProgress from '@mui/material/CircularProgress';
import PwaModal from '../../components/checkPwa/pwaModal';
import Logo from '../../assets/logo.png';
import getNotificationsPermission from '../../components/getNotificationsPermission';

const Login = () => {
  const api = ApiClient();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const phoneNumber = useSelector((st) => st?.auth?.phoneNumber);
  const [showPwa, setShowPwa] = useState(false);

  const handleInputChange = (newValue) => {
    if (newValue?.length <= 11) dispatch(setPhoneNumber(newValue));
  };

  const onSubmit = async () => {
    if (phoneNumber.length === 11 && phoneNumber.charAt(0) === '0') {
      const value = convertPersianToEnglish(phoneNumber);
      try {
        setIsLoading(true);
        setError('');
        const response = await api.get(
          `/api/app/v1/auth/check-username?username=${value}`
        );
        setIsLoading(false);
        navigate(`/password`);
      } catch (error) {
        if (error?.response && error?.response?.status === 404) {
          navigate(`/Register`);
        }
        if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          setError(error.response.data.message);
        }
      }
      setIsLoading(false);
    } else {
      setError('شماره موبایل وارد شده صحیح نمیباشد');
    }
  };

  useEffect(() => {
    checkPwaIos(setShowPwa);
    getNotificationsPermission();
  }, []);

  return (
    <AuthLayout>
      <PwaModal showPwa={showPwa} setShowPwa={setShowPwa} />
      <Stack
        justifyContent="center"
        alignItems="center"
        sx={{ width: '100%', mt: 4 }}
      >
        <img
          src={Logo}
          alt="Logo"
          style={{
            maxWidth: '150px',
            maxHeight: '150px',
            width: 'auto',
            height: 'auto',
          }}
        />
      </Stack>
      <Typography
        paddingRight={'20px'}
        paddingLeft={'20px'}
        fontSize={24}
        fontWeight={600}
        marginTop={'24px'}
      >
        ورود
      </Typography>
      <Typography
        paddingRight={'20px'}
        paddingLeft={'20px'}
        color={'primary.gray'}
        fontSize={16}
        fontWeight={600}
        marginTop={'12px'}
        marginBottom={'32px'}
      >
        لطفا، شمارهٔ موبایلتان را وارد نمایید.
      </Typography>
      <Grid
        container
        flexDirection={'column'}
        paddingRight={'20px'}
        paddingLeft={'20px'}
      >
        <Grid item>
          <InputBox
            label="شماره تلفن همراه"
            value={phoneNumber}
            setValue={handleInputChange}
            onSubmit={onSubmit}
            isLoading={isLoading}
            maxLength={11}
            type="number"
            icon={null}
            error={error}
          />
        </Grid>
        <Grid item>
          <Button
            onClick={onSubmit}
            disabled={isLoading}
            sx={{
              width: '100%',
              height: '57px',
              borderRadius: '8px',
              color: 'primary.contrastText',
              fontFamily: 'iran-sans-light',
              fontSize: '16px',
              fontWeight: '600',
              marginTop: '0px',
            }}
            size="large"
            variant="contained"
          >
            {isLoading ? <CircularProgress size={24} sx={{ color: 'primary.contrastText' }} /> : 'تایید و ادامه'}
          </Button>
        </Grid>
      </Grid>
    </AuthLayout>
  );
};

export default Login;
